export const environment = {
    production: false,
    version: '1.0.0.43',
    baseUrl: 'https://budget-test.hafencity.com',
    baseAPIUrl: 'https://budget-test.hafencity.com',
    auth: {
      clientId: '276cf6e2-9cb0-4b7e-b91e-d420ca8bbd3d',
      authority: 'https://login.microsoftonline.com/3e76597e-1e36-436c-ba37-c065ad9ef1f7',
      redirectUri: 'https://budget-test.hafencity.com',
      navigateToLoginRequestUrl: false
    }
  };
